var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPenSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9936 0C13.5828 0 14.1477 0.23525 14.5603 0.651005L17.3511 3.44149C17.7666 3.85695 18 4.42044 18 5.00799C18 5.59554 17.7666 6.15903 17.3511 6.57449L7.16174 16.7594C6.5331 17.4845 5.64199 17.93 4.62113 18H0V17.1001L0.00292302 13.307C0.0795943 12.3581 0.520799 11.4758 1.19384 10.8828L11.4258 0.652089C11.8407 0.234719 12.405 0 12.9936 0ZM4.55757 16.2025C5.03837 16.1684 5.48592 15.9447 5.8453 15.5337L12.651 8.72873L9.27207 5.35005L2.42649 12.1932C2.06185 12.5157 1.83627 12.9668 1.8 13.3795V16.2008L4.55757 16.2025ZM10.545 4.07756L13.9238 7.45608L16.0783 5.30184C16.1562 5.22391 16.2 5.11821 16.2 5.00799C16.2 4.89777 16.1562 4.79207 16.0783 4.71413L13.285 1.92115C13.2079 1.84348 13.103 1.79979 12.9936 1.79979C12.8842 1.79979 12.7793 1.84348 12.7022 1.92115L10.545 4.07756Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenSvg);
export default __webpack_public_path__ + "static/media/penSVG.a9d0add46ec07b57bdc83da9488d5524.svg";
export { ForwardRef as ReactComponent };